/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { guidFor } from "@ember/object/internals";
import Component from "@glimmer/component";
import type { EmberChangeset } from "ember-changeset";
import { validatePresence } from "ember-changeset-validations/validators";
import type FormyComponent from "../index";

interface Signature {
  Args: {
    formy: FormyComponent;
    key: string;
    label?: string;
  };
}

type IErr = EmberChangeset["error"][string];

export default class FormyFieldComponent extends Component<Signature> {
  id = guidFor(this);

  get error(): IErr["validation"] | undefined {
    const error = this.args.formy.args.changeset.error[this.args.key];

    if (!error) return;

    const errors = error.validation;
    if (!errors) return;

    return errors instanceof Array ? errors[0] : errors;
  }

  get errorId(): string | undefined {
    if (!this.error) return undefined;
    return guidFor(this.error);
  }

  private;

  _isPresenceValidation(validation: () => void): boolean {
    return validation.toString() === validatePresence().toString();
  }
}
